rdefine(['app/products/collections/Locations'],['backbone'],function(Backbone) {
    return Backbone.Ribs.Collection.extend({
        model:Backbone.Ribs.Model,
        initialize:function() {
            this.reset(window.locations);
        }
    });
});